/**
 * @author Brendan Magee
 * @desc Configuration for the Arc Nav component
 */

function arcNavConfig($translate, $http, filtersService, featureFlag, evidentlyFeatures) {
  const BASE_PATH = '/websked';
  const REACT_BASE_PATH = '/websked/1';

  const buildStoryParams = (filters) =>
    Object.keys(filters).reduce((acc, filter, index, src) => {
      let params = acc;
      const connector = index === src.length - 1 ? '' : '&';
      params += `${filter}=${filters[filter]}${connector}`;
      return params;
    }, '');

  const storyParams = buildStoryParams(filtersService.defaultFilters);

  let tasksv2enabled = false;
  featureFlag.isEnabled('tasksv2').then((enabled) => {
    tasksv2enabled = enabled;
  });

  // workaround for the fact that arcnav does not seem to support `target` prop in `sub` links
  window.addEventListener('goToCalendar', (e) => { window.location.href = `${REACT_BASE_PATH}/calendar/${e.detail.view}`; }, false);

  const weekSize = window.localStorage.getItem('arc.websked.weekSize');
  const enablePendo = !window.Cypress;

  const getConfigData = () =>
    Promise.all([
      $http({
        method: 'GET',
        url: '/websked/1/package.json'
      }),
      evidentlyFeatures.equalsStringValue(
        'should-use-content-api',
        'editorial-search-use-content-api'
      )
    ]).then(([reactVersionResponse, editorialSearchApiEnabled]) => {
      const data = {
        appname: 'WebSked',
        homeLink: {
          href: `${BASE_PATH}/`,
          usePushState: true
        },
        version: `${reactVersionResponse.data.version} / ${editorialSearchApiEnabled ? '2.0' : '1.0'}`,
        links: [
          {
            name: $translate.instant('PLANNING'),
            href: `${BASE_PATH}/list?${storyParams}`,
            usePushState: true,
            match: {
              path: [`${BASE_PATH}/list`, `${BASE_PATH}/stats`]
            },
            sub: [
              {
                name: $translate.instant('LIST_VIEW'),
                href: `${BASE_PATH}/list?${storyParams}`,
                usePushState: true,
                match: {
                  path: [`${BASE_PATH}/list`]
                }
              },
              {
                name: $translate.instant('DAY_VIEW', { numDays: 1 }),
                customEvent: {
                  type: 'goToCalendar',
                  detail: { view: '1' }
                }
              },
              {
                name: $translate.instant('DAY_VIEW', { numDays: weekSize || '7' }),
                customEvent: {
                  type: 'goToCalendar',
                  detail: { view: weekSize || '7' }
                }
              },
              {
                name: $translate.instant('STATS'),
                href: `${BASE_PATH}/stats/`,
                usePushState: true,
                match: {
                  path: [`${BASE_PATH}/stats/`]
                }
              }
            ]
          },
          {
            name: $translate.instant('TASKS'),
            href: tasksv2enabled
              ? `${REACT_BASE_PATH}/tasks`
              : `${BASE_PATH}/tasks/tasks-overview`,
            usePushState: !tasksv2enabled,
            target: tasksv2enabled ? '_self' : undefined,
            match: {
              path: `${BASE_PATH}/tasks`
            }
          },
          {
            name: $translate.instant('PUBLICATIONS'),
            href: `${BASE_PATH}/publications`,
            usePushState: true,
            match: {
              path: `${BASE_PATH}/publications`
            }
          },
          {
            name: $translate.instant('COLLECTIONS.TITLE_PL'),
            href: `${BASE_PATH}/collections`,
            target: '_self'
          }
        ],
        userLinks: [
          {
            name: $translate.instant('WEBSKED_USER_PROFILE'),
            href: `${BASE_PATH}/profile`,
            usePushState: true
          },
          {
            name: $translate.instant('GROUPS'),
            href: tasksv2enabled
              ? `${REACT_BASE_PATH}/groups`
              : `${BASE_PATH}/groups`,
            usePushState: !tasksv2enabled,
            target: tasksv2enabled ? '_self' : undefined
          },
          {
            name: $translate.instant('COMPANY'),
            href: `${BASE_PATH}/1/settings`,
            target: '_self'
          },
          {
            name: $translate.instant('USER_GUIDE'),
            href: '/alc/collection/ESBXOVWRI5BFPO4BW5OXQ44DMQ',
            target: '_self'
          }
        ],
        gtmId: 'GTM-N6QM9K7',
        customDatalayer: {
          appName: 'WebSked',
          app_version: '1'
        },
        enablePendo
      };

      return JSON.stringify(data);
    });

  return {
    buildStoryParams,
    getConfigData
  };
}

const factoryArray = [
  '$translate',
  '$http',
  'filtersService',
  'featureFlag',
  'evidentlyFeatures',
  arcNavConfig
];

export default function (ngModule) {
  ngModule.factory('arcNavConfig', factoryArray);
}
